export default "__VITE_ASSET__DqhBB67K__"